// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e510a6b7","732":"ab72b79c","977":"550e45c1"}[chunkId] + ".chunk.js";
};